import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { MessagingSettingsTab } from "../utils/types";

export function useMessagingPageTab() {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageTab = useMemo(() => {
    const raw = searchParams.get("tab");
    if (
      raw === MessagingSettingsTab.BOOKING ||
      raw === MessagingSettingsTab.EMAIL_TEMPLATES
    ) {
      return raw;
    }

    return MessagingSettingsTab.ARRIVAL;
  }, [searchParams]);

  const handlePageTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return { pageTab, handlePageTabChange };
}
